module.exports = __webpack_public_path__ + "img/mens_logo.6dec34b0.svg";